export default __webpack_public_path__ + "static/media/logo-meetpharma.0e376e0e.png";